<script>
import MainButton from "@/components/helpers/MainButton.vue";

/**
 * Карточка оффера (кастомный оффер из RC PAY) в разделе «Реферальные ссылки».
 * Данные оффера подтягиваются с backend-mobile (см. ReferralLinks.vue),
 * при недоступности API показывается только запасное название.
 */
export default {
  name: "OfferCard",
  components: { MainButton },

  props: {
    offer: {
      type: Object,
      required: true,
    },
  },

  computed: {
    // «До 300 RC» -> «до 300 RC» (выводится жирным)
    cashback() {
      return this.offer.cashback
        ? this.lowerFirst(this.offer.cashback).replace(/\brc\b/i, "RC")
        : null;
    },

    approveDays() {
      return this.offer.approveDays
        ? this.lowerFirst(this.offer.approveDays)
        : null;
    },
  },

  methods: {
    lowerFirst(text) {
      return text.charAt(0).toLowerCase() + text.slice(1);
    },
  },
};
</script>

<template>
  <div class="offer-card">
    <div v-if="offer.imageSrc" class="offer-card__image">
      <img :src="offer.imageSrc" :alt="offer.title" />
    </div>

    <h3>{{ offer.title }}</h3>

    <p v-if="cashback || approveDays">
      <template v-if="cashback">
        Кешбэк <strong>{{ cashback }}</strong>
      </template>
      <template v-if="cashback && approveDays">, </template>
      <template v-if="approveDays">начисление {{ approveDays }}</template>
    </p>

    <MainButton
      title="Перейти к офферу"
      color="gold"
      :href="offer.link"
      target="_blank"
    />
  </div>
</template>

<style lang="scss" scoped>
.offer-card {
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  border-radius: 16px;
  background: $light-second;

  @media screen and (max-width: 576px) {
    margin: 0 16px;
  }

  &__image {
    width: 100%;
    max-width: 220px;
    margin: 0 auto 16px auto;
    border-radius: 12px;
    overflow: hidden;
    background: $light-primary;

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  h3 {
    width: 100%;
    @include title-3;
    text-align: center;
    color: $dark-primary;
    margin-bottom: 8px;
  }

  p {
    width: 100%;
    @include body-1;
    text-align: center;
    color: $dark-third;
    margin-bottom: 24px;
  }

  // кнопка прижата к низу, чтобы карточки в сетке выравнивались по одной линии
  ::v-deep .main-button {
    width: 100%;
    margin-top: auto;
  }
}

@media (min-width: 900px) {
  .offer-card {
    padding: 32px;

    p {
      margin-bottom: 43px;
    }
  }
}
</style>
